/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
import React from "react";
export const SvgCalendar: React.FC<React.SVGAttributes<SVGElement>> = (
    props
) => (
    <svg viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="currentColor"
                d="M16.25 2a.75.75 0 01.75.75V3h4a1 1 0 011 1v17a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1h4v-.25a.75.75 0 011.5 0V3h7v-.25a.75.75 0 01.75-.75zm4.316 7.5H3.499l.001 11h17.067l-.001-11zM9.964 12c1.124 0 2.036.855 2.036 1.91 0 .375-.123.723-.334 1.01L11.6 15l.065.08c.184.251.302.55.328.87l.006.14c0 1.055-.911 1.91-2.036 1.91-.912 0-1.684-.573-1.935-1.386-.113-.368.113-.751.504-.858.36-.097.733.073.88.385l.034.088a.537.537 0 00.517.386c.31 0 .56-.235.56-.525a.405.405 0 00-.348-.391l-.194-.014c-.827-.101-.827-1.269 0-1.37l.118-.007.076-.007a.405.405 0 00.348-.391c0-.29-.25-.525-.56-.525a.534.534 0 00-.484.302l-.033.084c-.113.367-.522.579-.914.473-.391-.107-.617-.49-.504-.858C8.28 12.573 9.052 12 9.964 12zm6.029.596l.007.098v4.614c0 .382-.34.692-.76.692-.385 0-.703-.26-.753-.598l-.007-.094-.001-3.056-.21.173a.817.817 0 01-.991.022l-.082-.071a.646.646 0 01-.023-.904l.077-.074 1.48-1.218c.462-.38 1.184-.12 1.263.416zM7 4.5H3.5L3.499 8h17.067V4.5H17v.25a.75.75 0 01-1.5 0V4.5h-7v.25a.75.75 0 01-1.5 0V4.5z"
            />
            <path d="M0 0h24v24H0z" />
        </g>
    </svg>
);
